import { Flex, Typography } from "antd";
import DashboardMenu from "./DashboardMenu";
import SharePage from "../../utils/SharePage";
import styles from "./dashboard.module.scss";

const { Text } = Typography;

const DashboardHeader: React.FC<any> = ({ printRef, filters, setFilters }) => {
  return (
    <div style={{ width: "100%", display: "flex", height: "40px", alignItems: "center" }}>
      <div style={{ width: "60%", textAlign: "left" }}>
        <Flex align="center" gap={16} style={{ padding: "0px" }}>
          <Text style={{ margin: 0, fontSize: '20px', fontWeight: 400 }}>
            Dashboard
          </Text>
          <DashboardMenu setFilters={setFilters} />
          {filters?.[0]?.length && (
            <Text className={styles.dateValue}>{`${filters[0][0]} - ${filters[0][1]}`}</Text>
          )}
        </Flex>
      </div>
      <div style={{ width: "40%", textAlign: "right" }}>
        <SharePage printRef={printRef}></SharePage>
      </div>
    </div>
  );
};

export default DashboardHeader;
